import { Stack } from '@mui/material';
import DigitalStudioSteps from './digitalStudioSteps';
import { useTranslation } from 'react-i18next';
import DigitalStudioImageGallery from './digitalStudioImageGallery';
import digitalStudioData from '../../assets/data/digitalStudio.json';
import { useEffect } from 'react';

const DigitalStudioArtworks = () => {
    const {t} = useTranslation();

    const steps = [
        {label: t('digitalStudio.artworks.steps.1.label'), description: t('digitalStudio.artworks.steps.1.description'), fill: 33},
        {label: t('digitalStudio.artworks.steps.2.label'), description: t('digitalStudio.artworks.steps.2.description'), fill: 66},
        {label: t('digitalStudio.artworks.steps.3.label'), description: t('digitalStudio.artworks.steps.3.description'), fill: 100}
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                width='100%'
            >
                <DigitalStudioSteps list={steps}/>

                <DigitalStudioImageGallery list={digitalStudioData["artworks"]}/>
            </Stack>
        </>
    );
}

export default DigitalStudioArtworks;